/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { Field } from 'react-final-form';
import { css, StyleSheet } from 'aphrodite';
import { InputContainer, Text } from '@blend/enterprise-components';
import { omit } from 'lodash';

import { respondToAuthChallenge } from 'id-api/auth';
import { FormCard } from 'id-components/FormCard';
import { PasswordValidity } from 'id-components/UnauthenticatedApp/PasswordValidity';
import { useChallengeCookie, useLoginFlowSubmit } from 'id-utils/login';

import { confirmPasswordInputConfig, complianceInput } from './inputConfigs';
import { passwordInputConfigWithValidation } from 'id-constants/commonInputs';
import { ConfigContext } from 'id-components/ConfigContext/ConfigContext';

const styles = StyleSheet.create({
  row: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  spacer: {
    ':not(:last-child)': {
      marginBottom: 16,
    },
  },
});

type FormValues = Identity.API.UpdatePasswordChallenge & {
  confirmedPassword: string;
};

export const UpdatePasswordChallengePage: React.FC = ({}) => {
  const config = React.useContext(ConfigContext);
  const challengeCookieResult = useChallengeCookie();
  const username = challengeCookieResult.cookie?.username;
  const formValuesTransformer = (formValues: FormValues) => {
    return { ...omit(formValues, ['confirmedPassword']) };
  };
  const onSubmit = useLoginFlowSubmit(respondToAuthChallenge, formValuesTransformer);

  return (
    <FormCard<FormValues>
      headerTitle="Let's activate your account."
      id="it-UpdatePasswordChallenge"
      onSubmit={onSubmit}
      submitLabel="Activate account"
      showSSOButton={!!config.auth?.saml?.tprSSO?.allowTPRSSO}
    >
      <div className={css(styles.spacer)}>
        <InputContainer
          customComponentProps={{ children: username }}
          input={{ name: 'email' }}
          inputComponent={Text}
          label="Email"
          labelSize="sm"
          meta={{} as any}
        />
      </div>
      <Field {...passwordInputConfigWithValidation} />
      <Field {...confirmPasswordInputConfig} />
      <PasswordValidity />
      <div className={css(styles.spacer)}>
        <Field {...complianceInput} />
      </div>
    </FormCard>
  );
};
